import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/global.css'
import { getImageUrl, IMG_BASE_URL } from './utils'
import EventBus from './utils/event-bus'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 全局事件总线，用于跨组件通信（如登录状态变化、购物车数量更新）
Vue.prototype.$bus = EventBus

// 注册全局方法，模板中可直接使用 $imgUrl(path)
Vue.prototype.$imgUrl = getImageUrl
Vue.prototype.$imgBase = IMG_BASE_URL

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
